import { MemberStatusInput } from '@tribeplatform/gql-client/types';
import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMembersKey } from '../../utils/keys';
export const DefaultMembersLimit = 10;
export const DefaultMembersStatus = [
    MemberStatusInput.VERIFIED,
    MemberStatusInput.UNVERIFIED,
];
export const useMembers = (options) => {
    const { variables = {
        limit: DefaultMembersLimit,
        status: DefaultMembersStatus,
    }, fields = 'basic', useInfiniteQueryOptions, } = options || {};
    const { client } = useTribeClient();
    const membersKey = getMembersKey(variables, fields);
    return useInfiniteQuery(membersKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.members.list({ after, ...variables }, fields), useInfiniteQueryOptions);
};
export const useSpaceMembers = (options) => {
    const { variables, fields = 'basic', useInfiniteQueryOptions } = options || {};
    const { client } = useTribeClient();
    const spacesKey = getMembersKey(variables);
    return useInfiniteQuery(spacesKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.spaceMembers.listMembers({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useMembers.js.map